"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatRelativeWeek = void 0;

var moment_1 = __importDefault(require("moment"));

var formatRelativeWeek = function formatRelativeWeek(week) {
  var m = (0, moment_1.default)(week, 'YYYY-ww').startOf('week');
  var lastWeek = (0, moment_1.default)().subtract(1, 'week');

  if (m.isSame((0, moment_1.default)(), 'week') && m.isSame((0, moment_1.default)(), 'year')) {
    return 'This Week';
  } else if (m.isSame(lastWeek, 'week') && m.isSame(lastWeek, 'year')) {
    return 'Last Week';
  } else if (m.isSame((0, moment_1.default)(), 'year')) {
    return "".concat(m.format('MMMM D'), " - ").concat(m.clone().endOf('week').format('MMMM D'));
  } else {
    return "".concat(m.format('MMMM D, YYYY'), " - ").concat(m.clone().endOf('week').format('MMMM D, YYYY'));
  }
};

exports.formatRelativeWeek = formatRelativeWeek;